module.exports = __webpack_public_path__ + "static/media/comment-alt-check.259556b3.svg";